import SearchIcon from './search-icon.js';
export default SearchIcon;
